var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep89(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 125,
    viewBox: "0 0 78 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292889 116.293C-0.0976331 116.683 -0.0976291 117.317 0.292898 117.707L6.6569 124.071C7.04743 124.462 7.68059 124.462 8.07111 124.071C8.46164 123.68 8.46163 123.047 8.0711 122.657L2.41421 117L8.07103 111.343C8.46155 110.953 8.46155 110.319 8.07102 109.929C7.68049 109.538 7.04733 109.538 6.65681 109.929L0.292889 116.293ZM76 -3.71917e-06L76 107L78 107L78 -3.81835e-06L76 -3.71917e-06ZM67.0001 116L0.999993 116L1.00001 118L67.0001 118L67.0001 116ZM76 107C76 111.97 71.9706 116 67.0001 116L67.0001 118C73.0752 118 78 113.075 78 107L76 107Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep89);
export default __webpack_public_path__ + "static/media/laptop_step_8_9.96398c56f32060105ba713428841dfc4.svg";
export { ForwardRef as ReactComponent };